/**
 * InlineLoading Component
 * 
 * Small inline loading indicator for use within form fields.
 */

import React from 'react';
import { Loader2 } from 'lucide-react';

export interface InlineLoadingProps {
  /** Loading message */
  message?: string;
  /** Additional CSS classes */
  className?: string;
}

export function InlineLoading({ message = 'Loading...', className = '' }: InlineLoadingProps) {
  return (
    <div className={`flex items-center text-sm text-gray-500 ${className}`}>
      <Loader2 className="w-4 h-4 animate-spin mr-2" />
      {message}
    </div>
  );
}

/**
 * InlineLoadingBox Component
 * 
 * Loading indicator styled as a form field placeholder.
 */
export interface InlineLoadingBoxProps {
  /** Loading message */
  message?: string;
  /** Additional CSS classes */
  className?: string;
}

export function InlineLoadingBox({ message = 'Loading...', className = '' }: InlineLoadingBoxProps) {
  return (
    <div className={`flex items-center px-3 py-2 border border-gray-300 rounded-md bg-gray-50 ${className}`}>
      <Loader2 className="w-4 h-4 animate-spin mr-2 text-gray-400" />
      <span className="text-sm text-gray-500">{message}</span>
    </div>
  );
}
